import {Factory, Module} from './decorators';
import TokenService from 'app/services/token';

@Module({
    name: 'app.resource',
    modules: [TokenService],
})
@Factory('R', function($state, Restangular, TokenService){
    "ngInject";
    return Restangular.withConfig(function(RestangularConfigurer){
        RestangularConfigurer.setBaseUrl(`${baseConfig.backendUrl}/api/v1`);
        RestangularConfigurer.addFullRequestInterceptor(function(...args){
            let headers = args[4];
            let token = TokenService.get();
            if (token) {
                headers['Authorization'] = `Token ${token}`;
            }
        });
        RestangularConfigurer.addResponseInterceptor(
            function (data, operation, what, url, response) {
                var extractedData;
                if (operation === 'getList' && response.data.results) {
                    extractedData = response.data.results;
                    extractedData.count = response.data.count;
                    extractedData.next = response.data.next;
                    extractedData.previous = response.data.previous;
                } else {
                    extractedData = response.data;
                }
                return extractedData;
            }
        );
        RestangularConfigurer.setErrorInterceptor(
            function (response) {
                if (response.status === 401) {
                    TokenService.clear();
                    $state.go('r.login', {force: true});
                }
                return true;
            }
        );
    });
})
export default class Resource {}



// WEBPACK FOOTER //
// ./src/app/resource.js